<template>
    <div class="image-vip-container">
        <div class="vip-header">
            <h1 class="vip-title">尊享「图片素材」会员特权</h1>
            <p class="vip-subtitle">加入我们的会员计划，享受更多优质服务和独家权益</p>
        </div>

        <div class="vip-plans">
            <div
                v-for="(plan, index) in vipPlans"
                :key="index"
                class="vip-plan-card"
                :class="{ active: selectedPlan === index }"
                @click="selectPlan(index)"
            >
                <div class="plan-header">
                    <h2 class="plan-title">{{ plan.title }}</h2>
                    <div class="plan-price">
                        <span class="price-value">¥{{ plan.price }}</span>
                        <span class="price-period">/{{ plan.period }}</span>
                    </div>
                </div>

                <div class="plan-features">
                    <div class="feature-item" v-for="(feature, fIndex) in plan.features" :key="fIndex">
                        <i class="el-icon-check"></i>
                        <span>{{ feature }}</span>
                    </div>
                </div>

                <div class="plan-footer">
                    <el-button type="primary" class="select-button" @click="handlePayment(index)"> 立即开通 </el-button>
                </div>
                <div class="plan-tag" v-if="plan.tag">{{ plan.tag }}</div>
            </div>
        </div>
        
        <!-- 支付弹窗 -->
        <div class="pay-modal" v-if="showPayWay">
            <div class="pay-modal-con">
                <img class="modal-close" @click="closePayModal" src="@/assets/images/close.png" alt="" />
                <div class="modal-tit">{{ payType | getPayTitle }}</div>
                <div class="pay-con" v-if="!payType">
                    <div class="pay-icon" @click="handleClickPay('wechat')">
                        <img src="@/assets/images/wechat_pay.png" alt="" />
                        <div>微信支付</div>
                    </div>
                    <div class="pay-icon alipay" @click="handleClickPay('alipay')">
                        <img src="@/assets/images/ali_pay.png" alt="" />
                        <div>支付宝支付</div>
                    </div>
                </div>
                <div class="pay-qr" v-else>
                    <img :src="payUrl" alt="" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getPayUrl, getStatus } from '@/api/order';
import { getPriceList } from '@/api/findImage';
import { mapState } from 'vuex';

export default {
    name: 'ImageVip',
    data() {
        return {
            selectedPlan: 1, // 默认选中年度会员
            showPayWay: false,
            payType: '',
            payUrl: '',
            vipPlans: [
                {
                    title: '月度会员',
                    price: 39,
                    code: "M",
                    period: '月',
                    features: ['图片素材免费下载', '会员时长31天', '每日下载图片数10张'],
                    tag: '',
                },
                {
                    title: '年会员',
                    price: 299,
                    code: "Y",
                    period: '年',
                    features: ['图片素材免费下载', '会员时长366天', '每日下载图片数15张', '专属客服服务'],
                    tag: '官方推荐',
                },
                {
                    title: '三年会员',
                    price: 999,
                    code: "TY",
                    period: '三年',
                    features: ['图片素材免费下载', '会员时长1098天', '每日下载图片数15张', '专属客服服务'],
                },
            ],
        };
    },
    computed: {
        ...mapState('user', ['userInfo']),
        selectedPlanInfo() {
            return this.vipPlans[this.selectedPlan];
        },
    },
    filters: {
        getPayTitle(payType) {
            const titles = {
                wechat: '请使用微信支付',
                alipay: '请使用支付宝支付',
                common: '对公支付请添加企微对接'
            };
            return titles[payType] || '请选择支付方式';
        },
    },
    mounted() {
        this.getPriceList();
    },
    methods: {
        getPriceList() {
            getPriceList().then((res) => {
                this.vipPlans.forEach((plan) => {
                    const item = (res.data || []).find((item) => item.code === plan.code);
                    if (item) {
                        plan.price = item.price;
                        plan.title = item.name;
                    }
                });
            });
        },
        selectPlan(index) {
            this.selectedPlan = index;
        },
        handlePayment(index) {
            if (!this.userInfo) {
                this.$router.push({ name: 'Login' });
                return;
            }
            this.selectPlan(index)
            this.showPayWay = true;
            
        },
        closePayModal() {
            this.payUrl = '';
            this.payType = '';
            this.showPayWay = false;
        },
        handleClickPay(payType) {
            getPayUrl({
                memberCode: this.selectedPlanInfo.code || '',
                type: 5,
                payType,
            })
                .then((res) => {
                    this.payType = payType;
                    this.payUrl = res.data.data;
                    this.getPayResult(res.data.orderId);
                })
                .catch(() => {
                    this.payUrl = '';
                });
        },
        getPayResult(id) {
            setTimeout(() => {
                getStatus(id)
                    .then((res) => {
                        if (res.data.code === 1 || res.data.code === 3) {
                            this.$message.success(`恭喜你，已成功开通「图片素材」${this.selectedPlanInfo.title}`);
                            this.closePayModal();
                            setTimeout(() => {
                                this.$router.go(-1)
                            }, 1500);
                        } else if (res.data.code === 2) {
                            this.getPayResult(id);
                        } else {
                            this.$message.error(res.data.msg || '支付失败，请重试');
                            this.closePayModal();
                        }
                    })
                    .catch(() => {
                        this.closePayModal();
                    });
            }, 3000);
        },
    },
};
</script>

<style lang="scss" scoped>
.image-vip-container {
    margin: 0 auto;
    padding: 40px 20px;
    color: #333;
}

.vip-header {
    text-align: center;
    margin-bottom: 50px;

    .vip-title {
        font-size: 36px;
        font-weight: bold;
        margin-bottom: 15px;
        color: #333;
    }

    .vip-subtitle {
        font-size: 18px;
        color: #666;
    }
}

.vip-plans {
    display: flex;
    justify-content: center;
    gap: 30px;
    margin-bottom: 50px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
    }
}

.vip-plan-card {
    width: 437px;
    box-sizing: content-box;
    box-shadow: 0px 1px 2px 0px rgba(0,0,0,0.05);
    border-radius: 12px;
    border: 2px solid transparent;
    overflow: visible;
    transition: all 0.3s ease;
    cursor: pointer;
    position: relative;
    background-color: #fff;
    padding: 34px;
    display: flex;
    flex-direction: column;

    &.active {
        border: 2px solid #2F54EB;
    }

    .plan-header {
        text-align: center;

        .plan-title {
            font-size: 22px;
            font-weight: bold;
            margin-bottom: 15px;
            color: #333;
        }

        .plan-price {
            margin-bottom: 10px;

            .price-value {
                font-size: 30px;
                font-weight: bold;
                color: #000;
            }

            .price-period {
                font-size: 16px;
                color: #6B7280;
            }
        }
    }

    .plan-features {
        flex: 1;
        .feature-item {
            display: flex;
            align-items: center;
            margin-bottom: 15px;

            i {
                color: #6366F1;
                margin-right: 10px;
                font-size: 16px;
                font-weight: 600;
            }

            span {
                font-size: 16px;
                color: #000000;
            }
        }
    }

    .plan-footer {
        text-align: center;
        margin-top: 20px;

        .select-button {
            width: 100%;
            border-radius: 50px;
            color: #fff;
            background: #2f54eb;
            font-weight: 500;
            font-size: 16px;
            height: 54px;
            &:hover {
                background: #597EF7;
            }
        }
    }

    .plan-tag {
        position: absolute;
        display: inline-block;
        width: 88px;
        height: 24px;
        top: -12px;
        font-size: 14px;
        left: calc(50% - 44px);
        background: #2F54EB;
        color: #fff;
        padding: 2px 10px;
        border-radius: 12px;
        text-align: center;
    }
}

.pay-modal {
    position: fixed;
    z-index: 10;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;

    .pay-modal-con {
        background: #fff;
        border-radius: 8px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        position: relative;

        .modal-tit {
            font-weight: 400;
            font-size: 20px;
            color: #272c40;
            margin: 20px 0 15px;
            text-align: center;
        }

        .modal-close {
            position: absolute;
            right: -60px;
            top: -25px;
            width: 50px;
            height: 50px;
            cursor: pointer;
        }

        .pay-con {
            padding: 0 59px 50px;
            display: flex;

            .pay-icon {
                width: 130px;
                height: 115px;
                background: #f7fff7;
                border-radius: 6px;
                border: 1px solid #09bb07;
                margin-right: 24px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                font-weight: 400;
                font-size: 16px;
                color: #333;
                cursor: pointer;

                &:hover {
                    background: #deffde;
                }

                &.alipay {
                    background: #f7faff;
                    border-color: #1677ff;
                    &:hover {
                        background: #e3edff;
                    }
                }

                img {
                    width: 43px;
                    margin-bottom: 16px;
                }

                &:last-child {
                    margin-right: 0;
                }
            }
        }

        .pay-qr {
            box-sizing: content-box;
            width: 200px;
            padding: 0 50px 30px;
            img {
                width: 200px;
            }
        }
    }
}
</style>
